import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { IS_URL_DEFAULT_OPTIONS } from '@ftr/contracts/shared/validator/IsUrlDefaultOptions'
import { isURL } from 'class-validator'

export const invalidUrlMessage = 'You must enter a valid URL e.g. https://some.url.com/some-where'

export const urlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value
  return isURL(value, IS_URL_DEFAULT_OPTIONS) ? null : { invalidURL: invalidUrlMessage }
}

export const invalidRTSPUrlMessage = 'You must enter a valid URL e.g. rtsp://192.168.1.1/camera.amp'

export const rtspValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value
  return isURL(value, { ...IS_URL_DEFAULT_OPTIONS, protocols: ['rtsp'], require_tld: false })
    ? null
    : { invalidURL: invalidRTSPUrlMessage }
}

export const validateOptionalUrl: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  return control.value ? urlValidator(control) : null
}
